import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _LIST_ESTABLISHMENT = async (searchData = false) => {
  let url = ServiceUrl.MOB.LIST_ESTABLISHMENT;
  return callApi(url, "post", searchData && searchData);
};

export const _ADD_ESTABLISHMENT = async (searchData = false) => {
  let url = ServiceUrl.MOB.ADD_ESTABLISHMENT;
  return callApi(url, "post", searchData && searchData);
};
